export const getIdFromUrl = () => {
  const url = window.location.href;
  return url.substring(url.lastIndexOf("/") + 1);
};
